// selectOptions.js

export const GENDER_OPTIONS = [
  { value: "female", label: "Groom" },
  { value: "male", label: "Bride" },
];

export const MOTHER_TONGUE_OPTIONS = [
  { value: "tamil", label: "Tamil" },
  { value: "sinhala", label: "Sinhalam" },
  { value: "english", label: "English" },
];

export const PROFILE_CREATED_BY_OPTIONS = [
  { value: "Self", label: "Self" },
  { value: "Parent", label: "Parent" },
  { value: "Sibling", label: "Sibling" },
  { value: "Relative", label: "Relative" },
  { value: "Friend", label: "Friend" },
  { value: "Guardian", label: "Guardian" },
];

export const MARITAL_STATUS_OPTIONS = [
  { value: "unMarried", label: "UnMarried" },
  { value: "divorced", label: "Divorced" },
  { value: "widowed", label: "Widowed" },
  { value: "nullified", label: "Nullified" },
];

export const CHILDREN_OPTIONS = [
  { value: "none", label: "None" },
  { value: "1", label: "1" },
  { value: "2", label: "2" },
  { value: "3+", label: "3+" },
];

export const KIDS_LIVE_WITH_OPTIONS = [
  { value: "parents", label: "With Parents" },
  { value: "mother", label: "With Mother" },
  { value: "father", label: "With Father" },
  { value: "self", label: "With Self" },
  { value: "other", label: "None" },
];

export const RELIGION_OPTIONS = [
  { value: "hindu", label: "Hindu" },
  { value: "christian", label: "Christian" },
  { value: "other", label: "Other" },
];

export const CASTE_OPTIONS = [
  // ───── VELLALAR GROUP ─────
  { value: "pure_jaffna_vellalar", label: "Pure Jaffna Vellalar" },
  { value: "mixed_jaffna_vellalar", label: "Mixed Jaffna Vellalar" },
  { value: "other_vellalar", label: "Other Vellalar" },

  // ───── BRAHMIN ─────
  { value: "brahmin", label: "Brahmin" },
  { value: "iyer", label: "Iyer" },
  { value: "iyengar", label: "Iyengar" },

  // ───── MUKKULATHOR GROUP ─────
  { value: "mukkulathor", label: "Mukkulathor" },
  { value: "thevar", label: "Thevar" },
  { value: "maravar", label: "Maravar" },
  { value: "kallar", label: "Kallar" },
  { value: "agamudaiyar", label: "Agamudaiyar" },

  // ───── COASTAL / FISHING ─────
  { value: "karaiyar", label: "Karaiyar" },
  { value: "paravar", label: "Paravar" },

  // ───── AGRICULTURAL / TRADITIONAL ─────
  { value: "nalavar", label: "Nalavar" },
  { value: "pallar", label: "Pallar" },
  { value: "koviyar", label: "Koviyar" },
  { value: "vannar", label: "Vannar" },
  { value: "ambattar", label: "Ambattar (Barber)" },

  // ───── ARTISAN / SERVICE ─────
  { value: "visvakarma", label: "Visvakarma" },
  { value: "kammalar", label: "Kammalar" },
  { value: "achari", label: "Achari" },
  { value: "goldsmith", label: "Goldsmith" },
  { value: "carpenter", label: "Carpenter" },

  // ───── MERCHANT / BUSINESS ─────
  { value: "chettiar", label: "Chettiar" },
  { value: "nadar", label: "Nadar" },
  { value: "pillai", label: "Pillai" },

  // ───── SRI LANKAN SPECIFIC ─────
  { value: "kurukulam_karaiyar", label: "Kurukulam / Karaiyar" },
  { value: "thattar", label: "Thattar" },

  // ───── GENERIC OPTIONS ─────
  { value: "other", label: "Other" },
  { value: "prefer_not_to_say", label: "Prefer not to say" },
];

export const ZODIAC_OPTIONS = [
  { value: "mesham", label: "Mesham" },
  { value: "rishabham", label: "Rishabham" },
  { value: "mithunam", label: "Mithunam" },
  { value: "kadakam", label: "Kadakam" },
  { value: "simmam", label: "Simmam" },
  { value: "kanni", label: "Kanni" },
  { value: "thulam", label: "Thulam" },
  { value: "virudshikam", label: "Virudshikam" },
  { value: "dhanushu", label: "Dhanushu" },
  { value: "makaram", label: "Makaram" },
  { value: "kumbham", label: "Kumbham" },
  { value: "meenam", label: "Meenam" },
];

export const STAR_PATHAM_OPTIONS = [
  { value: "1", label: "1st Patham" },
  { value: "2", label: "2nd Patham" },
  { value: "3", label: "3rd Patham" },
  { value: "4", label: "4th Patham" },
  { value: "not_applicant", label: "Not Applicant" },
];

export const STAR_OPTIONS = [
  { value: "ashwini", label: "Ashwini" },
  { value: "bharani", label: "Bharani" },
  { value: "krittikai", label: "Krittikai" },
  { value: "rohini", label: "Rohini" },
  { value: "mirugashiridam", label: "Mirugashiridam" },
  { value: "thiruvathirai", label: "Thiruvathirai" },
  { value: "punarpoosam", label: "Punarpoosam" },
  { value: "poosham", label: "Poosham" },
  { value: "ayiliam", label: "Ayiliam" },
  { value: "maham", label: "Maham" },
  { value: "pooram", label: "Pooram" },
  { value: "uthiram", label: "Uthiram" },
  { value: "hastham", label: "Hastham" },
  { value: "chiththirai", label: "Chiththirai" },
  { value: "swathi", label: "Swathi" },
  { value: "visakam", label: "Visakam" },
  { value: "anusham", label: "Anusham" },
  { value: "keddai", label: "Keddai" },
  { value: "moolam", label: "Moolam" },
  { value: "puradam", label: "Puradam" },
  { value: "uthiradam", label: "Uthiradam" },
  { value: "thiruvonam", label: "Thiruvonam" },
  { value: "aviddam", label: "Aviddam" },
  { value: "sadayam", label: "Sadayam" },
  { value: "puraddathi", label: "Puraddathi" },
  { value: "uthirattathi", label: "Uthirattathi" },
  { value: "revathy", label: "Revathy" }
];

export const BODY_TYPE_OPTIONS = [
  { value: "slim", label: "Slim" },
  { value: "average", label: "Average" },
  { value: "athletic", label: "Athletic" },
  { value: "heavy", label: "Heavy" },
];

export const PHYSICAL_STATUS_OPTIONS = [
  { value: "normal", label: "Normal" },
  { value: "physically_challenged", label: "Physically Challenged" },
];

export const HEIGHT_OPTIONS = [
  { value: "4 feet 5in - 135cm", label: "4 feet 5in - 135cm" },
  { value: "4 feet 6in - 137.5cm", label: "4 feet 6in - 137.5cm" },
  { value: "4 feet 7in - 140cm", label: "4 feet 7in - 140cm" },
  { value: "4 feet 8in - 142.5cm", label: "4 feet 8in - 142.5cm" },
  { value: "4 feet 9in - 145cm", label: "4 feet 9in - 145cm" },
  { value: "4 feet 10in - 147.5cm", label: "4 feet 10in - 147.5cm" },
  { value: "4 feet 11in - 150cm", label: "4 feet 11in - 150cm" },
  { value: "5 feet - 152.5cm", label: "5 feet - 152.5cm" },
  { value: "5 feet 1in - 155cm", label: "5 feet 1in - 155cm" },
  { value: "5 feet 2in - 157.5cm", label: "5 feet 2in - 157.5cm" },
  { value: "5 feet 3in - 160cm", label: "5 feet 3in - 160cm" },
  { value: "5 feet 4in - 162.5cm", label: "5 feet 4in - 162.5cm" },
  { value: "5 feet 5in - 165cm", label: "5 feet 5in - 165cm" },
  { value: "5 feet 6in - 167.5cm", label: "5 feet 6in - 167.5cm" },
  { value: "5 feet 7in - 170cm", label: "5 feet 7in - 170cm" },
  { value: "5 feet 8in - 172.5cm", label: "5 feet 8in - 172.5cm" },
  { value: "5 feet 9in - 175cm", label: "5 feet 9in - 175cm" },
  { value: "5 feet 10in - 177.5cm", label: "5 feet 10in - 177.5cm" },
  { value: "5 feet 11in - 180cm", label: "5 feet 11in - 180cm" },
  { value: "6 feet - 182.5cm", label: "6 feet - 182.5cm" },
  { value: "6 feet 1in - 185cm", label: "6 feet 1in - 185cm" },
  { value: "6 feet 2in - 187.5cm", label: "6 feet 2in - 187.5cm" },
  { value: "6 feet 3in - 190cm", label: "6 feet 3in - 190cm" },
  { value: "6 feet 4in - 192.5cm", label: "6 feet 4in - 192.5cm" },
  { value: "6 feet 5in - 195cm", label: "6 feet 5in - 195cm" },
];

export const WEIGHT_OPTIONS = [
  { value: "40 Kg", label: "40 Kg" },
  { value: "45 Kg", label: "45 Kg" },
  { value: "50 Kg", label: "50 Kg" },
  { value: "55 Kg", label: "55 Kg" },
  { value: "60 Kg", label: "60 Kg" },
  { value: "65 Kg", label: "65 Kg" },
  { value: "70 Kg", label: "70 Kg" },
  { value: "75 Kg", label: "75 Kg" },
  { value: "80 Kg", label: "80 Kg" },
  { value: "85 Kg", label: "85 Kg" },
  { value: "90 Kg", label: "90 Kg" },
  { value: "95 Kg", label: "95 Kg" },
  { value: "100 Kg", label: "100 Kg" },
  { value: "105 Kg", label: "105 Kg" },
  { value: "110 Kg", label: "110 Kg" },
  { value: "115 Kg", label: "115 Kg" },
  { value: "120 Kg", label: "120 Kg" },
];

export const COMPLEXION_OPTIONS = [
  { value: "very_fair", label: "Very Fair" },
  { value: "fair", label: "Fair" },
  { value: "wheatish", label: "Wheatish" },
  { value: "dark", label: "Dark" },
];

export const COUNTRY_OPTIONS = [
  { value: "Sri Lanka", label: "Sri Lanka" },
  { value: "India", label: "India" },
  { value: "United States", label: "United States" },
  { value: "United Kingdom", label: "United Kingdom" },
  { value: "Canada", label: "Canada" },
  { value: "Australia", label: "Australia" },
  { value: "New Zealand", label: "New Zealand" },
  { value: "Singapore", label: "Singapore" },
  { value: "Malaysia", label: "Malaysia" },
  { value: "France", label: "France" },
  { value: "Germany", label: "Germany" },
  { value: "Italy", label: "Italy" },
  { value: "Switzerland", label: "Switzerland" },
  { value: "Norway", label: "Norway" },
  { value: "Sweden", label: "Sweden" },
  { value: "Denmark", label: "Denmark" },
  { value: "Netherlands", label: "Netherlands" },
  { value: "Belgium", label: "Belgium" },
  { value: "United Arab Emirates", label: "United Arab Emirates" },
  { value: "Qatar", label: "Qatar" },
  { value: "Kuwait", label: "Kuwait" },
  { value: "Saudi Arabia", label: "Saudi Arabia" },
  { value: "Oman", label: "Oman" },
  { value: "Bahrain", label: "Bahrain" },
  { value: "South Africa", label: "South Africa" },
  { value: "Japan", label: "Japan" },
  { value: "South Korea", label: "South Korea" },
  { value: "China", label: "China" },
  { value: "Thailand", label: "Thailand" },
  { value: "Indonesia", label: "Indonesia" },
  { value: "Pakistan", label: "Pakistan" },
  { value: "Bangladesh", label: "Bangladesh" },
  { value: "Nepal", label: "Nepal" },
  { value: "Maldives", label: "Maldives" },
];

export const RESIDENT_STATUS_OPTIONS = [
  { value: "citizen", label: "Citizen" },
  { value: "permanent_resident", label: "Permanent Resident" },
  { value: "work_permit", label: "Work Permit" },
  { value: "student_visa", label: "Student Visa" },
  { value: "visitor_visa", label: "Visitor Visa" },
  { value: "refuguee", label: "Refugee" },
  { value: "other", label: "Other" },
];

export const SEVVAI_LAKNA_OPTIONS = [
  { value: "Nil", label: "Nil" },
  { value: "in 2-4-12", label: "in 2-4-12" },
  { value: "in 1-7-8", label: "in 1-7-8" },
  { value: "Not Applicant", label: "Not Applicant" },
];

export const EATING_HABIT_OPTIONS = [
  { value: "Vegetarian", label: "Vegetarian" },
  { value: "Non-Vegetarian", label: "Non-Vegetarian" },
  { value: "Eggetarian", label: "Eggetarian" },
  { value: "Vegan", label: "Vegan" },
];

export const DRINKING_HABIT_OPTIONS = [
  { value: "No", label: "No" },
  { value: "Occasionally", label: "Occasionally" },
  { value: "Yes", label: "Yes" },
];

export const SMOKING_HABIT_OPTIONS = [
  { value: "No", label: "No" },
  { value: "Occasionally", label: "Occasionally" },
  { value: "Yes", label: "Yes" },
];